/**
 * Created by lari on 24/04/2017. **/

(function () {
  'use strict';
  angular.module('vcdms.vcfile')
    .component('complexfilelist', {
      restrict: 'E',
      bindings: {
        files: '<',
        key: '@?',
        value: '@?'
      },
      templateUrl: 'vcdms/file/complexfilelist-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', '$scope', 'uiGridConstants', 'vertxEventBusService', 'File',
        function ($log, $http, Rlog, $scope, uiGridConstants, vertxEventBusService, File) {
          let vm = this;
          vm.fileactiontemplate = 'fileactiontemplate';
          vm.filetagtemplate = 'filetagtemplate';
          vm.getTags = getTags;
          vm.saveFile = saveFile;
          vm.removeFile = removeFile;
          vm.unlinkFile = unlinkFile;
          vm.spinners = [];

          // init
          vm.$onInit = function () {
            if (angular.isUndefined(vm.files)) {
              if (angular.isString(vm.key) && angular.isString(vm.value)) {
                vm.mode = 'patient';
                // vm.files = File.$searchBy(vm.key, vm.value);
                let query = {active: {$ne: false}, sharetype: {$ne: 'generic'}};
                query[vm.key] = vm.value;
                vm.files = File.$search(query);
              } else {
                vm.mode = 'generic';
                vm.files = File.$search({active: {$ne: false}});
              }
            } else {
              vm.mode = 'generic';
            }

            vm.gridOptions = {
              enableFiltering: true,
              enableSorting: true,
              columnDefs: [
                {
                  field: 'created', displayName: 'Datum', type: 'date', width: '15%',
                  cellTemplate: '<div class="ui-grid-cell-contents"><span>{{row.entity.created | moment: \'lll\'}}</span></div>',
                  filters: [
                    {
                      condition: uiGridConstants.filter.GREATER_THAN,
                      placeholder: 'nach'
                    },
                    {
                      condition: uiGridConstants.filter.LESS_THAN,
                      placeholder: 'vor'
                    }
                  ],
                  sort: {
                    direction: uiGridConstants.DESC,
                    priority: 1
                  }
                },
                {
                  field: 'type', displayName: 'Typ', width: '20%',
                  filter: {
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: 'beinhaltet ...'
                  }
                },
                {
                  displayName: 'Stichworte', name: 'flattags', cellClass: 'gridalignleft', width: '49%',
                  cellTemplate: vm.filetagtemplate, enableFiltering: true,
                  filter: {
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: 'beinhaltet ...'
                  }
                },
                {
                  displayName: 'Aktion', name: 'fileaction', cellClass: 'gridalignright', width: '16%',
                  cellTemplate: vm.fileactiontemplate, enableFiltering: false, enableSorting: false
                }
              ],
              data: vm.files,
              onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
              }
            };
          };

          function getTags(val) {
            // TODO: evaluate need for ^ regex to beginning of tag
            // let myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
            let myregex = val; // when using $regex, do not include '/' for regex delimiter
            let match = [
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$unwind: '$flattags'},
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$group: {_id: '$flattags', total: {$sum: 1}}}];

            return $http.post('/routes/files/aggregate', match).then(function (response) {
              $log.debug('tags received: ', response);
              let tags = new Set();
              if (angular.isDefined(response) && angular.isDefined(response.data) && response.data.length > 0) {
                // create set to group by value
                tags = new Set(response.data.map(function (tag) {
                  return tag._id;
                }));
              } else if (angular.isDefined(response) && angular.isDefined(response.data) &&
                angular.isDefined(response.data._id)) {
                tags = new Set([response.data._id]);
                $log.debug('tags: ', tags);
              }
              // return array because ngTagsLib expects an array not a set
              $log.debug('array working: ', Array.from(tags));

              return Array.from(tags);
            });
          }


          function saveFile(doc) {
            $log.debug('debug - saveFile called!');
            let flattags = [];
            $log.debug('doc: ', doc);
            if (angular.isArray(doc.keywords)) {
              for (let i = 0; i < doc.keywords.length; i++) {
                flattags.push(doc.keywords[i].text);
              }
              doc.flattags = flattags;
              doc.$save().$then(function () {
                vm.files.$refresh().$then(function () {
                  vm.gridApi.core.refresh();
                });
              });
            }
          }

          function removeFile(file) {
            $log.debug('debug - removeFile: ', file);
            file.active = false;
            file.$save().$then(function () {
              vm.files.$refresh().$then(function () {
                vm.gridApi.core.refresh();
              });
            });
          }

          function unlinkFile(file) {
            delete file.doccat;
            delete file.type;
            delete file.signature;
            delete file.signedoff;
            delete file.patientname;
            delete file.patientid;
            // TODO: figure out correct jobid, processingstate after fileimport refactoring
            file.jobid = 'scan';
            file.processingstate = 'unprocessed';
            file.$save().$then(function () {
              vm.files.$refresh().$then(function () {
                vm.gridApi.core.refresh();
              });
            });
          }

          vm.helpunlink = 'Wenn Sie die Dateizuordnung aufheben, wird die Datei wieder in die Scan- bzw. Dateizuordnungliste eingereiht und kann erneut zugeordnet werden. W&auml;hlen Sie diese Option zum Beispiel dann, wenn Sie eine Datei der falschen Person zugeordnet haben.';


          const filesCreateHandler = function (message) {
            // $log.debug('debug: document update received: ', message);
            if (angular.isDefined(vm.files)) {
              vm.files.$refresh().$then(function () {
                $log.debug('debug: documentlist refreshed documents');
              }, function (error) {
                $log.debug('debug: documentlist refresh documents failed: ', error);
              });
            }
          };

          vertxEventBusService.on('files.create', {}, filesCreateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('files.create', {}, filesCreateHandler);
          };

        }] // controller
    }); // component

  // klammerfriedhof
}());
